import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import { FieldError } from "react-hook-form";
import { css, Theme } from "@theme";
import { LAYOUT_CONFIG } from "./PatientNotesConstants";
import { ENABLE_AI_NOTES } from "@resources/constants";
import { VoiceToTextButton } from "@/components/VoiceToTextButton";

interface PatientNotesTextAreaProps {
  value: string;
  onChange: (value: string) => void;
  error?: FieldError;
  disabled?: boolean;
  isExpanded?: boolean;
}

const styles = {
  textArea: (theme: Theme) => css`
    background-color: ${theme.palette.common.white};
    // background-color: blue;
    margin-top: ${LAYOUT_CONFIG.textAreaMarginTop};
    .MuiInputBase-root {
      padding: ${LAYOUT_CONFIG.textAreaTopPadding} 1rem 0.5rem 1rem;
    }
    .MuiOutlinedInput-notchedOutline {
      // border-radius: 4px;
      border-radius: 0;
      border: none;
    }
    legend {
      display: none;
    }
  `,
};

export const PatientNotesTextArea: React.FC<PatientNotesTextAreaProps> = React.memo((p) => {
  const { value, onChange, error, disabled, isExpanded } = p;

  return (
    <TextField
      css={styles.textArea}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      multiline
      rows={isExpanded ? 24 : ENABLE_AI_NOTES ? 18 : 10}
      variant="outlined"
      placeholder="Add your notes here..."
      error={Boolean(error)}
      helperText={error?.message}
      disabled={disabled}
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" sx={{ alignSelf: "flex-start", mt: 1.5, mr: 0.5 }}>
            <VoiceToTextButton disabled={disabled} />
          </InputAdornment>
        ),
      }}
    />
  );
});

PatientNotesTextArea.displayName = "PatientNotesTextArea";
